import {useEffect} from "react";
import {usePage} from "@inertiajs/react";
import isEmpty from "is-empty";
import {useDiscountFirstOrderModal} from "@/features/discount-firs-order-modal";

let timerPromoCodeFirstOrder = null;

export default function useShowDiscountOnFirstOrder() {
    const {props} = usePage();
    const {mobileApp = false, promoCodeFirstOrder = null} = props;

    const openModal = useDiscountFirstOrderModal(state => state.actions.openModal);

    useEffect(() => {
        /**
         * Очистка таймера если был установлен ранее
         */
        if (promoCodeFirstOrder === null && timerPromoCodeFirstOrder) {
            clearTimeout(timerPromoCodeFirstOrder);
        }

        /**
         * Проходим далее если:
         * 1. Есть промокод на скидку на первый заказ (определяет сервер)
         * 2. Окно показывается впервые
         * 3. Если открыли не из приложения
         */
        if (
            promoCodeFirstOrder === null ||
            timerPromoCodeFirstOrder ||
            !isEmpty(sessionStorage.getItem('discountFirstOrder')) ||
            mobileApp
        ) {
            return;
        }

        timerPromoCodeFirstOrder = setTimeout(() => {
            openModal(); // Показываем модальное окно "Скидка на первый заказ"
        }, 30000); // 30 секунд = 30000 миллисекунд
    }, [promoCodeFirstOrder]);
}
